<template>
    <div>
        <el-form label-position="top">
            <el-row :gutter="10">
                <el-col :xs="24" :sm="18" :md="18">
                    <el-form-item key="periodo">
                        <el-select @change="getMatriculasTempoReal()" v-model="filtro.periodo_id">
                            <el-option v-for="(item, i) in $store.state.periodos" :key="i" :label="'Periodo Letivo ' + item.nome" :value="item.id"></el-option>                     
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="6" :md="6" class="u-text-right">
                    <el-button @click="getMatriculasTempoReal()" type="primary">ATUALIZAR</el-button>
                </el-col>
            </el-row>
        </el-form>
        <div class="container-table">           
           
            <table class="table table-striped">
                <thead>
                    <tr>
                        <th>Instituição</th>
                        <th class="u-text-right">Turmas</th>
                        <th class="u-text-right">Vagas</th>
                        <th class="u-text-right">Alunos</th>
                        <th class="u-text-right">Matrículas</th>
                        <th class="u-text-right">Ocupação</th>
                        <th style="width: 150px;" class="u-text-center">Ação</th>
                    </tr>
                </thead>
                <tbody v-if="!loading">
                    <tr v-for="(item, i) in itens.dados" :key="i">
                        <td>{{ i }}</td>
                        <td class="u-text-right">{{ item.qtd_turmas }}</td>
                        <td class="u-text-right">{{ item.qtd_vagas }}</td>
                        <td class="u-text-right">{{ item.qtd_regular }}</td>
                        <td class="u-text-right">{{ item.qtd_matriculados }}</td>
                        <td class="u-text-right">{{ item.ocupacao }}%</td>                        
                        <td class="u-text-center acao"> 
                            <el-button @click="showDetalhes(item, i)" title="Visualizar" type="primary" size="mini" plain>
                                <i class="fas fa-search"></i>
                            </el-button>
                        </td>
                    </tr>
                    <tr v-if="itens.resumo && itens.dados && Object.keys(itens.dados).length > 1" style="background-color: #efefef;">
                        <td><b>TOTAIS</b></td>
                        <td class="u-text-right"><b>{{ itens.resumo.turmas_totais }}</b></td>
                        <td class="u-text-right"><b>{{ itens.resumo.vagas_totais }}</b></td>
                        <td class="u-text-right"><b>{{ itens.resumo.alunos_totais }}</b></td>
                        <td class="u-text-right"><b>{{ itens.resumo.matriculas_totais }}</b></td>
                        <td class="u-text-right"><b>{{ itens.resumo.ocupacoes_totais }}%</b></td>                        
                        <td class="u-text-center acao"></td>
                    </tr>
                </tbody>
            </table>

            <div v-if="loading" class="u-text-center u-mt-25">
                <img src="/public/img/loading-bar.gif" />
            </div>
        </div>


        <el-dialog :close-on-click-modal="false" title="DETALHES MATRÍCULA EM TEMPO REAL" :visible.sync="dialogDetalhes">
            <div v-if="dialogDetalhes" style="margin-top: 20px;">
                <h3>{{ instituicaoSelected }}</h3>
                <div class="container-table">           
                    <table class="table table-striped">
                        <thead>
                            <tr>
                                <th>Turma</th>
                                <th class="u-text-right">Vagas</th>
                                <th class="u-text-right">Matrículas</th>
                                <th class="u-text-right">Ocupação</th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-for="(item, i) in itemSelected">
                                <tr :key="i" v-if="i != 'qtd_vagas' && i != 'qtd_turmas' && i != 'qtd_matriculados' && i != 'ocupacao' && i != 'qtd_regular'">
                                    <td>{{ i }}</td>
                                    <td class="u-text-right">{{ item.vagas }}</td>
                                    <td class="u-text-right">{{ item.matriculas }}</td>
                                    <td class="u-text-right">{{ item.ocupacao }}%</td>
                                </tr>
                            </template>
                        </tbody>
                    </table>
                </div>
                <el-row :gutter="10">
                    <el-col :xs="24" class="u-text-right">
                        <el-button class="u-mt-20" size="small" type="danger" @click="dialogDetalhes = false">FECHAR</el-button>
                    </el-col>
                </el-row>
            </div>
        </el-dialog>

    </div>
</template>
<script>

export default {
    data: () => ({
        filtro:{
            periodo_id: ''
        },
        dialogDetalhes: false,
        loading: false,
        itens: [ ],
        itemSelected: {},
        instituicaoSelected: ''
    }),
    mounted () {

        this.filtro.periodo_id = JSON.parse(JSON.stringify(this.$store.state.config.periodo.id));

        this.getMatriculasTempoReal()
    },
    methods: {
        showDetalhes(item, instituicaoSelected){

            this.itemSelected = item;
            this.instituicaoSelected = instituicaoSelected;
            this.dialogDetalhes = true;
        },
        getMatriculasTempoReal(){

            this.loading = true;
            this.itens = [];

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/instituicao/getMatriculasTempoReal/${this.filtro.periodo_id}`, this.$store.getters.getHeaderAuth).then(response => {

                this.itens = response.data;
                this.loading = false;

            }).catch((error) => { this.$store.commit('throwException', error); });

        }
    },
    components:{  }
}
</script>